import React from 'react'
import DashboardMapFilter from '../../components/dashboard/DashboardMapFilter'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import { Box } from '@mui/material'
import SubTitle from '../../components/common/SubTitle'
import Footer from '../../components/common/Footer'

export default function AllRouteTrack() {
    const orgName = JSON.parse(localStorage.getItem('userState'))?.organization?.name;

    return (
        <>
            <TitleBar />
            <NavMenu />
            <SubTitle
                title="Monitor Routes"
                path={`${orgName || "organization"} > Routes > Monitor Routes`}
            />
            <Box
                sx={{
                    border: "none", position: "relative"
                    ,
                    margin: { xs: "0px 20px", md: "0px 40px" },
                    boxShadow: "-2px 1px 5px 1px #00000040",
                    borderRadius: "10px",

                    border: "1px solid #A5DCF3"
                }}
            >
                <DashboardMapFilter />
            </Box>
            <Box style={{
                height: "5vh"
            }}>
            </Box>
            <Footer />
        </>
    )
}
